<template>
  <v-layout column>

    <v-form ref="form">

      <h3>PAIS DIVORCIADOS? / ARE THE PARENTS DIVORCED?</h3>
      <v-radio-group v-model="resource.form.divorced_parents" row :rules="radioRule">
        <v-radio label="SIM/YES" :value="true"/>
        <v-radio label="NÃO/NO" :value="false"/>
      </v-radio-group>

      <v-text-field
        outline
        v-model="resource.form.daily_caretaker"
        label="COM QUEM O ALUNO FICA DURANTE O DIA / WHO TAKES CARE OF THE CHILD DURING THE DAY?"
      />

      <v-layout row wrap>
        <v-flex d-flex xs12 sm6 md6>
          <v-text-field
            outline
            v-model="resource.form.caretaker_phone"
            label="TELEFONE/PHONE"
          />
        </v-flex>
      </v-layout>

      <v-text-field
        outline
        v-model="resource.form.anyone_speaks_english"
        label="ALGUÉM FALA INGLÊS EM CASA? SIM, QUEM? / DOES ANYONE SPEAK ENGLISH AT HOME? IF YES, WHO?"
      />

      <v-text-field
        outline
        v-model="resource.form.family_main_language"
        label="QUAL A LÍNGUA QUE FALAM EM CASA? WHAT LANGUAGE IS SPOKEN AT HOME?"
      />

    </v-form>
  </v-layout>
</template>

<script>

/**
 * @group Form
 * Componente de form para dados de Histórico Familiar
 */
export default {
  name: 'FormFamiliarHistory',

  data: () => ({
    emptyRule: [v => !!v || 'Campo obrigatório/Field is required'],
    radioRule: [v => typeof v === 'boolean' || 'Campo obrigatório/Field is required']
  }),

  inject: ['resource'],

  computed: {
    resource () {
      return this.resource
    }
  },

  methods: {
    /**
     * @vuese
     * Método para validação da form
     */
    validateForm () {
      return this.$refs.form.validate()
    }
  }
}
</script>
